// The table's narrow layout applies below 768px, the same point as its stylesheets' narrow rules.

import { useEffect, useState } from 'react'

export const NARROW_QUERY = '(max-width: 767.98px)'

const query = () =>
  typeof window !== 'undefined' && typeof window.matchMedia === 'function'
    ? window.matchMedia(NARROW_QUERY)
    : null

/** @returns {{narrow: boolean}} */
export const useBreakpoint = () => {
  const [narrow, setNarrow] = useState(() => {
    const list = query()
    return Boolean(list && list.matches)
  })

  useEffect(() => {
    const list = query()
    if (!list) return undefined
    const onChange = () => setNarrow(list.matches)
    onChange()
    // Safari before 14 has only the deprecated listener API
    if (list.addEventListener) list.addEventListener('change', onChange)
    else list.addListener(onChange)
    return () => {
      if (list.removeEventListener) list.removeEventListener('change', onChange)
      else list.removeListener(onChange)
    }
  }, [])

  return { narrow }
}
